import BaseCommand from "@/models/api/commands/BaseCommand";

export class CurrencyChangeCommand extends BaseCommand {
  CommandName = "CurrencyChange";
  Command: string;
  constructor(sessionId: string, operationId: string, currency: string) {
    super(sessionId, operationId);
    this.Command = currency;
  }
}
